import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ServicesPage from "@/pages/ServicesPage";
import PricingPage from "@/pages/PricingPage";
import ClientsPage from "@/pages/ClientsPage";
import ServicePage from "@/pages/ServicePage";
import AIAdsPage from "@/pages/AIAdsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/ai-ads" element={<AIAdsPage />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/ai-ads" element={<Navigate to="/services/ai-ads" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
